import { eventBus } from 'EventBus/';

export const bus = {
  name: 'bus',
  bind: (el, { modifiers, value }) => {
    if (modifiers && 'object' === typeof modifiers) {
      Object.keys(modifiers).forEach((eventName) => {
        if (eventName !== 'prevent') {
          el.addEventListener(eventName, (e) => {
            if (eventName === 'click' && modifiers.prevent) {
              e.preventDefault();
            }
            eventBus.$emit(value);
          });
        }
      });
    }
  },
};
